export const environment = {
    production: true
    , hmr: false
    , appUrl: 'http://roscarrazo.mx/roscarrazoService/api/'
    , messageDuration: 10000
};
